import styled from "styled-components"

export const MeetingModulesWrapper = styled.div`
  max-height: 100px;
`;